import { containsArabicScript } from "./arabicConversions";

export const DEFAULT_MATCH_TYPE = "all";

export const normalizeSearchRequest = (requestBody = {}) => {
  const normalized = { ...requestBody };

  if (normalized.sort_param === "relevance") {
    delete normalized.sort_param;
    delete normalized.sort_type;
  }

  if (!normalized.enable_translation) {
    delete normalized.language;
    delete normalized.target_language;
    return normalized;
  }

  if (!normalized.target_language) {
    normalized.target_language = "ar";
  }

  if (containsArabicScript(normalized.search_term)) {
    normalized.language = "ar";
  }

  return normalized;
};

// Capture these once per results navigation. localStorage also holds draft
// controls, so reading it again during pagination can silently change a search.
export const getSubmittedSearchRequest = (state = {}, storage = localStorage) => {
  const read = (key, fallback) => {
    try {
      const value = storage.getItem(key);
      return value === null ? fallback : JSON.parse(value);
    } catch {
      return fallback;
    }
  };
  const request = state?.searchRequest;
  return {
    search_term: request?.search_term ?? state?.searchString ?? read("searchTerm", ""),
    match_type: request?.match_type ?? state?.matchType ?? read("matchType", DEFAULT_MATCH_TYPE),
    enable_translation: request?.enable_translation ?? read("enableTranslation", false),
    language: request?.language ?? read("selectedLanguage", { code: "en" })?.code,
    target_language: request?.target_language ?? read("selectedTargetLanguage", { code: "ar" })?.code,
  };
};

export const getHighlightSearchTerm = (request, translatedTerm) => {
  // The search backend skips translation for Arabic input (including mixed
  // script queries) and searches the submitted text. No translated term in
  // that case does not mean there is no query to highlight.
  if (!request.enable_translation || containsArabicScript(request.search_term)) {
    return request.search_term || "";
  }
  return translatedTerm || "";
};
